import React from 'react';
import './Loader.css'; // Assuming styles are defined in a separate CSS file

const Loader = ({ small = false }) => (
    <div className={small ? 'loader_small' : 'loader_component'}></div>
);

export default Loader;
